<template>
  <svg xmlns="http://www.w3.org/2000/svg" :width="width" :height="height" viewBox="0 0 20 20" fill="none">
    <path d="M6.07519 17.3507L1.66603 18.3307L2.64603 13.9216C2.00063 12.7144 1.66396 11.3663 1.66603 9.9974C1.66603 5.3949 5.39686 1.66406 9.99936 1.66406C14.6019 1.66406 18.3327 5.3949 18.3327 9.9974C18.3327 14.5999 14.6019 18.3307 9.99936 18.3307C8.63049 18.3328 7.28237 17.9961 6.07519 17.3507V17.3507ZM6.31686 15.5899L6.86103 15.8816C7.82648 16.3975 8.90469 16.6663 9.99936 16.6641C11.3179 16.6641 12.6068 16.2731 13.7032 15.5405C14.7995 14.808 15.654 13.7668 16.1586 12.5486C16.6631 11.3304 16.7952 9.99 16.5379 8.69679C16.2807 7.40359 15.6458 6.2157 14.7134 5.28335C13.7811 4.351 12.5932 3.71606 11.3 3.45883C10.0068 3.20159 8.66631 3.33362 7.44814 3.8382C6.22996 4.34278 5.18877 5.19727 4.45623 6.29359C3.72369 7.38992 3.33269 8.67885 3.33269 9.9974C3.33269 11.1091 3.60353 12.1791 4.11603 13.1357L4.40686 13.6799L3.86102 16.1357L6.31686 15.5899V15.5899Z" :fill="color ? color:'#040410'" />
  </svg>
</template>
<script lang="ts">
import { Component, Prop, Vue } from 'vue-property-decorator'

@Component({
  name: 'WcIconNotes'
})
export default class extends Vue {
  @Prop({ default: '#040410' }) private color!: String
  @Prop({ default: '20' }) height!: String;
  @Prop({ default: '20' }) width!: String;
}
</script>

<style scoped>
</style>
